'use client';

import { NestedStatusEnum } from '@/config/steps.config';
import clsx from 'clsx';
import { useSearchParams } from 'next/navigation';
import Tag from '@repo/ui/Tag';

interface MainTagWrapperProps extends React.HTMLAttributes<HTMLElement> {}

const MainTagWrapper = ({
  children,
  className,
  ...rest
}: MainTagWrapperProps) => {
  const searchParams = useSearchParams();
  const isNested = searchParams.get(NestedStatusEnum.NESTED) !== null;
  const SemTag = isNested ? 'main' : 'div';

  return (
    <Tag
      tagName={SemTag}
      className={clsx(
        'flex-grow flex flex-col is-full max-is-[40rem] mli-auto pli-4',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default MainTagWrapper;
